export enum ERROR {
    IS_FUTURE_REQUIRED = 'IS_FUTURE_REQUIRED',
}
